<ng-container *transloco="let t">
  @if (hasPriceDiscount()) {
    <span class="previous-price">{{ price() | currencyFormat }}</span>
    <span class="current-price">{{ priceDiscount() | currencyFormat }}</span>
    <span class="discount-percentage">
      <pxw-tag type="success" size="xs">
        {{
          t('product.priceDiscountPercentage', {
            discountPercentage: price() | pxwPriceDiscount: priceDiscount(),
          })
        }}
      </pxw-tag>
    </span>
  } @else {
    <span class="current-price">{{ price() | currencyFormat }}</span>
  }

  @if (displayProductPriceWithoutTaxes()) {
    <span class="price-without-taxes">
      <span class="price-without-taxes__wrapper">
        <span class="helper">Precio sin impuestos: </span>
        {{ priceWithoutTaxes() | currencyFormat }}
      </span>
    </span>
  }
</ng-container>
